import { createApi } from "@reduxjs/toolkit/query/react";
import { listCatalogResponse, listCatalogRequest } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import { generateUniqueCatalogId } from "../../utils/helpers";
import { upsertCatalogItems } from "../../reducers/catalogItemsSlice";

export const catalogApi = createApi({
  reducerPath: "catalogApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Catalog"],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    listCatalog: builder.query<listCatalogResponse, listCatalogRequest>({
      query: (params) => ({
        url: "/catalog",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(
                ({ source, id }) =>
                  ({
                    type: "Catalog",
                    id: generateUniqueCatalogId(source, id),
                  }) as const,
              ),
              { type: "Catalog", id: "LIST" },
            ]
          : [{ type: "Catalog", id: "LIST" }],
      onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(upsertCatalogItems(data.items));
        } catch (error) {
          withErrorNotification("Failed to fetch catalog images");
        }
      },
    }),
    invalidateCatalog: builder.mutation<void, void>({
      queryFn: () => ({ data: undefined }),
      invalidatesTags: ["Catalog"],
    }),
  }),
});

export const {
  useListCatalogQuery,
  usePrefetch,
  useInvalidateCatalogMutation,
} = catalogApi;
